const validate = (values, language) => {
  const errors = {};
  if (!values.firstname) {
    errors.firstname = language.RegisterManagedPartyValidation.noFirstname;
  }
  if (!values.lastname) {
    errors.lastname = language.RegisterManagedPartyValidation.noLastname;
  }
  if (!values.civicRegistrationNumber) {
    errors.civicRegistrationNumber =
      language.RegisterManagedPartyValidation.noCivicRegistrationNumber;
  }
  if (values.civicRegistrationNumber.length > 0) {
    if (
      !/^(19|20)[0-9]{6}[- ]?[0-9]{4}$/.test(values.civicRegistrationNumber)
    ) {
      errors.civicRegistrationNumber = `Ogiltigt personnummer`;
    }
  }

  return errors;
};

export default validate;
